export default __webpack_public_path__ + "static/media/preview.a2346b91.jpg";